// محتوى قسم البرامج (يُتحكم به بالكامل من هنا)
import SettingsSuggestRoundedIcon from "@mui/icons-material/SettingsSuggestRounded";
import LinkRoundedIcon from "@mui/icons-material/LinkRounded";

export const PROGRAM = {
  title: "برنامج الكاشير والمحاسبة ",
  badge: "المحاسب المحترف",
  subtitle:
    "حل متكامل لنقاط البيع وإدارة المخزون والمالية، مصمم للسوق السعودي ويدعم العربية والفوترة الإلكترونية.",
  bullets: [
    "واجهة عربية بسيطة تدعم الشاشات اللمسية.",
    "فواتير إلكترونية (فاتورة) وإرسالها عبر البريد/الواتساب.",
    "تتبع المخزون مع تنبيهات نقص الكميات.",
    "تقارير مالية وضريبية مفصلة.",
    "صلاحيات متعددة للمستخدمين مع سجل نشاط.",
  ],
  ctas: {
    siteLabel: "تصفح موقع البرنامج",
    consultLabel: "جرب الان مجانا",
  },
  industries: [
    "مطاعم ومقاهي",
    "سوبرماركت وبقالات",
    "مواد بناء وسباكة",
    "ملابس وأقمشة",
    "أدوات مكتبية",
    "مكاتب وإكسسوارات",
  ],
  preview: {
    main: {
      title: "لوحة التقارير",
      subtitle: "مبيعات اليوم • أفضل المنتجات • أداء الفروع",
    },
    cards: [
      {
        title: "مرونة",
        desc: "إعدادات ضريبة، عملات، وحدات قياس، خصومات وعروض.",
        Icon: SettingsSuggestRoundedIcon,
      },
      {
        title: "تكامل",
        desc: "إمكانية الربط مع طابعات وميزان وباركود وأنظمة أخرى.",
        Icon: LinkRoundedIcon,
      },
    ],
  },
};
